import { NSARouterMakerResult } from 'namirasoft-account-react';
import { NamirasoftMap } from 'namirasoft-site-map';
import { NSBox, NSBoxBoolean, NSBoxEntity, NSBoxString, NSColumn, NSRow } from 'namirasoft-site-react';
import { AssignmentInputRow, AssignmentRow, StorageRow, StorageUserRow } from 'namirasoft-storage';
import { Component, createRef } from 'react';
import { StorageEntities } from '../StorageEntities';
import { StorageLayout } from '../StorageLayout';
import { StorageRouterProps } from '../StorageRouterProps';

export interface AssignmentEditPageProps extends NSARouterMakerResult, StorageRouterProps
{
    isEdit: boolean;
}

export default class AssignmentEditPage extends Component<AssignmentEditPageProps>
{
    private NSBoxEntity_StorageUserID = createRef<NSBoxEntity<StorageUserRow>>();
    private NSBoxEntity_StorageID = createRef<NSBoxEntity<StorageRow>>();
    private NSBoxString_PathSource = createRef<NSBoxString>();
    private NSBoxString_PathDestination = createRef<NSBoxString>();
    private NSBoxBoolean_CanList = createRef<NSBoxBoolean>();
    private NSBoxBoolean_CanDownload = createRef<NSBoxBoolean>();
    private NSBoxBoolean_CanCreateFile = createRef<NSBoxBoolean>();
    private NSBoxBoolean_CanCreateDirectory = createRef<NSBoxBoolean>();
    private NSBoxBoolean_CanOverwriteFile = createRef<NSBoxBoolean>();
    private NSBoxBoolean_CanDeleteFile = createRef<NSBoxBoolean>();
    private NSBoxBoolean_CanDeleteDirectory = createRef<NSBoxBoolean>();
    private NSBoxBoolean_CanRename = createRef<NSBoxBoolean>();
    private NSBoxBoolean_CanCopy = createRef<NSBoxBoolean>();
    private NSBoxBoolean_CanMove = createRef<NSBoxBoolean>();

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

        return (
            <StorageLayout<AssignmentRow, AssignmentInputRow>
                {...this.props}
                pages={{
                    entity: StorageEntities.assignment(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): AssignmentInputRow =>
                                    {
                                        return {
                                            storage_user_id: this.NSBoxEntity_StorageUserID.current?.getValueOne() ?? "",
                                            storage_id: this.NSBoxEntity_StorageID.current?.getValueOne() ?? "",
                                            path_source: this.NSBoxString_PathSource.current?.getValue() ?? "",
                                            path_destination: this.NSBoxString_PathDestination.current?.getValue() ?? "",
                                            can_list: this.NSBoxBoolean_CanList.current?.getValueBool() ?? false,
                                            can_download: this.NSBoxBoolean_CanDownload.current?.getValueBool() ?? false,
                                            can_create_file: this.NSBoxBoolean_CanCreateFile.current?.getValueBool() ?? false,
                                            can_create_directory: this.NSBoxBoolean_CanCreateDirectory.current?.getValueBool() ?? false,
                                            can_overwrite_file: this.NSBoxBoolean_CanOverwriteFile.current?.getValueBool() ?? false,
                                            can_delete_file: this.NSBoxBoolean_CanDeleteFile.current?.getValueBool() ?? false,
                                            can_delete_directory: this.NSBoxBoolean_CanDeleteDirectory.current?.getValueBool() ?? false,
                                            can_rename: this.NSBoxBoolean_CanRename.current?.getValueBool() ?? false,
                                            can_copy: this.NSBoxBoolean_CanCopy.current?.getValueBool() ?? false,
                                            can_move: this.NSBoxBoolean_CanMove.current?.getValueBool() ?? false,
                                        } as AssignmentInputRow;
                                    },
                                    setRow: (row: AssignmentRow) =>
                                    {
                                        this.NSBoxEntity_StorageUserID.current?.setValueOne(row.storage_user_id);
                                        this.NSBoxEntity_StorageID.current?.setValueOne(row.storage_id);
                                        this.NSBoxString_PathSource.current?.setValue((row as any).path_source);
                                        this.NSBoxString_PathDestination.current?.setValue((row as any).path_destination);
                                        this.NSBoxBoolean_CanList.current?.setValueBool(row.can_list);
                                        this.NSBoxBoolean_CanDownload.current?.setValueBool(row.can_download);
                                        this.NSBoxBoolean_CanCreateFile.current?.setValueBool(row.can_create_file);
                                        this.NSBoxBoolean_CanCreateDirectory.current?.setValueBool(row.can_create_directory);
                                        this.NSBoxBoolean_CanOverwriteFile.current?.setValueBool(row.can_overwrite_file);
                                        this.NSBoxBoolean_CanDeleteFile.current?.setValueBool(row.can_delete_file);
                                        this.NSBoxBoolean_CanDeleteDirectory.current?.setValueBool(row.can_delete_directory);
                                        this.NSBoxBoolean_CanRename.current?.setValueBool(row.can_rename);
                                        this.NSBoxBoolean_CanCopy.current?.setValueBool(row.can_copy);
                                        this.NSBoxBoolean_CanMove.current?.setValueBool(row.can_move);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn style={{ maxWidth: "35rem" }}>
                    <NSRow style={{ justifyContent: "flex-start" }}>
                        <NSBoxEntity<StorageUserRow>
                            ref={this.NSBoxEntity_StorageUserID}
                            title="Storage User"
                            required
                            multiple={false}
                            table={namirasoft.storage.tables.storage_user}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                        <NSBoxEntity<StorageRow>
                            ref={this.NSBoxEntity_StorageID}
                            title="Storage"
                            required
                            multiple={false}
                            table={namirasoft.storage.tables.storage}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                        <NSBoxString
                            ref={this.NSBoxString_PathSource}
                            title="Path Source"
                            required={false}
                            style={{ width: "100%" }}
                        />
                        <NSBoxString
                            ref={this.NSBoxString_PathDestination}
                            title="Path Destination"
                            required={false}
                            style={{ width: "100%" }}
                        />
                        <NSBoxBoolean
                            ref={this.NSBoxBoolean_CanList}
                            title="Can List"
                            hideHeader={true}
                            required={true}
                        />
                        <NSBoxBoolean
                            ref={this.NSBoxBoolean_CanDownload}
                            title="Can Download"
                            hideHeader={true}
                            required={true}
                        />
                        <NSBoxBoolean
                            ref={this.NSBoxBoolean_CanCreateFile}
                            title="Can Create File"
                            hideHeader={true}
                            required={true}
                        />
                        <NSBoxBoolean
                            ref={this.NSBoxBoolean_CanCreateDirectory}
                            title="Can Create Directory"
                            hideHeader={true}
                            required={true}
                        />
                        <NSBoxBoolean
                            ref={this.NSBoxBoolean_CanOverwriteFile}
                            title="Can Overwrite File"
                            hideHeader={true}
                            required={true}
                        />
                        <NSBoxBoolean
                            ref={this.NSBoxBoolean_CanDeleteFile}
                            title="Can Delete File"
                            hideHeader={true}
                            required={true}
                        />
                        <NSBoxBoolean
                            ref={this.NSBoxBoolean_CanDeleteDirectory}
                            title="Can Delete Directory"
                            hideHeader={true}
                            required={true}
                        />
                        <NSBoxBoolean
                            ref={this.NSBoxBoolean_CanRename}
                            title="Can Rename"
                            hideHeader={true}
                            required={true}
                        />
                        <NSBoxBoolean
                            ref={this.NSBoxBoolean_CanCopy}
                            title="Can Copy"
                            hideHeader={true}
                            required={true}
                        />
                        <NSBoxBoolean
                            ref={this.NSBoxBoolean_CanMove}
                            title="Can Move"
                            hideHeader={true}
                            required={true}
                        />
                    </NSRow>
                </NSColumn>
            </StorageLayout>
        );
    }
}